<template>
  <div 
    class="mt-5">
    <v-dialog
      v-model="dialog"
      width="1000px"
      persistent
      scrollable>
      <v-card>
        <v-card-title class="headline">Update Data Pemakaian / Penggunaan</v-card-title>
        <v-divider 
          class="mb-2"
          style="border-top: 2px dashed #e0e0e0;"/>
        <v-card-text>
          <ValidationObserver 
            ref="form">
            <v-form>
              <v-row>
                <v-col cols="12" md="5">
                  <ValidationProvider 
                    name="Nama Lengkap" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
    
                      Nama Lengkap
                    </div>
    
                    <v-text-field
                      v-on:keyup.enter="save()"
                      
                      outlined
                      rounded
                      dense
    
                      :color="set_color"
                      placeholder="Contoh. John Doe"
    
                      hide-details
    
                      v-model="form.name"
                      :error-messages="errors"
                      required
                      style="border-radius: 4px;"
                      class="mb-4">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form.name !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
    
                  <ValidationProvider 
                    name="Email" 
                    rules="required|email" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
    
                      Email
                    </div>
    
                    <v-text-field
                      v-on:keyup.enter="save()"
                      
                      outlined
                      rounded
                      dense
    
                      :color="set_color"
                      placeholder="Contoh. xxx@hmail.com"
                      hide-details
                      v-model="form.email"
                      :error-messages="errors"
                      required
                      style="border-radius: 4px;"
                      class="mb-4">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form.email !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                  <ValidationProvider 
                    name="Nomor Handphone" 
                    rules="required|min:10" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
    
                      Nomor Handphone
                    </div>
    
                    <v-text-field
                      v-on:keyup.enter="save()"
                      
                      outlined
                      rounded
                      dense
    
                      :color="set_color"
                      placeholder="Contoh. 08123456789"
                      hide-details
                      v-model="form.mobilephone"
                      :error-messages="errors"
                      required
                      type="number"
                      style="border-radius: 4px;"
                      class="mb-4">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form.mobilephone !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                  <ValidationProvider 
                    name="NIK" 
                    rules="required|min:16" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
    
                      NIK
                    </div>
    
                    <v-text-field
                      v-on:keyup.enter="save()"
                      
                      outlined
                      rounded
                      dense
    
                      :color="set_color"
                      placeholder="Contoh. 1234567890123456"
                      hide-details
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      type="number"
                      v-model="form.nik"
                      :error-messages="errors"
                      required
                      style="border-radius: 4px;"
                      class="mb-4">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form.nik !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                  <div class="mt-2 pb-5">
                    <div class="d-flex align-center justify-space-between">
                      <!-- Tanggal Mulai -->
                      <div style="width: 47%;">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>
                          Tanggal Mulai
                        </div>
                        <v-menu
                          v-model="menuStart"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="startFormatted"
                              placeholder="Pilih tanggal mulai"
                              readonly
                              outlined
                              dense
                              disabled
                              hide-details
                              v-bind="attrs"
                              v-on="on"
                              class="form-input"
                              style="border-radius: 4px;"
                            />
                          </template>
                          <v-date-picker
                            v-model="form.start_date"
                            :min="today"
                            :allowed-dates="allowedDates"
                            @input="menuStart = false"
                            color="primary"
                          />
                        </v-menu>
                      </div>

                      <div class="px-2 pt-6">~</div>

                      <!-- Tanggal Selesai -->
                      <div style="width: 47%;">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>
                          Tanggal Selesai
                        </div>
                        <v-menu
                          v-model="menuEnd"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="endFormatted"
                              placeholder="Pilih tanggal selesai"
                              readonly
                              outlined
                              dense
                              hide-details
                              disabled
                              v-bind="attrs"
                              v-on="on"
                              class="form-input"
                              style="border-radius: 4px;"
                            />
                          </template>
                          <v-date-picker
                            v-model="form.end_date"
                            :min="form.start_date || today"
                            :allowed-dates="allowedDates"
                            @input="menuEnd = false"
                            color="primary"
                          />
                        </v-menu>
                      </div>
                    </div>
                  </div>

                  <ValidationProvider 
                    name="Nama Event" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
    
                      Nama Event
                    </div>
    
                    <v-text-field
                      v-on:keyup.enter="save()"
                      
                      outlined
                      rounded
                      dense
    
                      :color="set_color"
                      placeholder="Contoh. Event Name"
                      hide-details
                      v-model="form.event_name"
                      :error-messages="errors"
                      required
                      style="border-radius: 4px;"
                      class="mb-4">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form.event_name !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                  <ValidationProvider 
                    name="Deskripsi Event" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
    
                      Deskripsi Event
                    </div>
    
                    <v-textarea
                      v-on:keyup.enter="save()"
                      
                      outlined
                      rounded
                      dense
    
                      :color="set_color"
                      placeholder="Contoh. Deskripsi Event"
                      hide-details
                      v-model="form.event_description"
                      :error-messages="errors"
                      required
                      style="border-radius: 4px;"
                      class="mb-4">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form.event_description !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-textarea>
                  </ValidationProvider>
                  <ValidationProvider 
                    name="Alamat" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
    
                      Alamat
                    </div>
    
                    <v-textarea
                      v-on:keyup.enter="save()"
                      
                      outlined
                      rounded
                      dense
    
                      :color="set_color"
                      placeholder="Contoh. Alamat Lengkap"
                      hide-details
                      v-model="form.address"
                      :error-messages="errors"
                      required
                      style="border-radius: 4px;"
                      class="mb-4">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form.address !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-textarea>
                  </ValidationProvider>

                  <div class="mt-3">
                    <div class="form-group pb-4">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Upload Foto KTP
                      </div>
                      <uploadfolder v-model="upload.image" style="height: 200px; width: 200px;">
                        <template #activator>
                          <v-card
                            flat
                            height="200"
                            class="d-flex align-center justify-center"
                            style="border-radius: 15px; border: 2px solid #eaeaea; border-style: dashed;">
                            
                            <div v-if="form.nik_url.length < 1">
                              <v-icon v-if="!process.ktp" size="60" color="grey">
                                mdi-cloud-upload-outline
                              </v-icon>

                              <v-progress-circular v-else indeterminate :color="set_color" />
                            </div>

                            <v-img
                              v-else
                              contain
                              height="200"
                              :src="cdnFallback['nik_url'] ? getCdnLegacyDisplayUrl(form.nik_url) : getCdnDisplayUrl(form.nik_url)"
                        @error="cdnFallback = { ...cdnFallback, 'nik_url': true }"
                              :alt="form.nik_url"
                              class="text-center d-flex align-center">
                              
                              <div class="d-flex align-center justify-center" style="width: 100%; height: auto;">
                                <v-icon v-if="!process.ktp" size="60" color="white">
                                  mdi-cloud-upload-outline
                                </v-icon>

                                <v-progress-circular v-else indeterminate :color="set_color" />
                              </div>
                            </v-img>
                          </v-card>
                        </template>
                      </uploadfolder>
                    </div>

                    <div class="mt-3">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Upload Proposal / Permohonan
                      </div>
                      <v-card flat height="250">
                        <v-card-title class="pa-0 text-center">
                          <div v-if="form.proposal_url.length < 1 || form.proposal_url.split('.').pop() !== 'pdf'" style="width: 100%;">
                            <uploadImgPdf v-model="upload.proposal" style="height: 250px; width: 100%;">
                              <template #activator>
                                <v-card
                                  flat
                                  height="250"
                                  class="d-flex align-center justify-center"
                                  style="border-radius: 15px; border: 2px solid #eaeaea; border-style: dashed; width: 100%;">
                                  
                                  <div v-if="form.proposal_url.length < 1">
                                    <v-icon v-if="!process.proposal" size="60" color="grey">
                                      mdi-cloud-upload-outline
                                    </v-icon>
            
                                    <v-progress-circular v-else indeterminate :color="set_color" />
                                  </div>
            
                                  <v-img
                                    v-else
                                    contain
                                    height="250"
                                    :src="cdnFallback['proposal_url'] ? getCdnLegacyDisplayUrl(form.proposal_url) : getCdnDisplayUrl(form.proposal_url)"
                        @error="cdnFallback = { ...cdnFallback, 'proposal_url': true }"
                                    :alt="form.proposal_url"
                                    class="text-center d-flex align-center">
                                    
                                    <div class="d-flex align-center justify-center" style="width: 100%; height: auto;">
                                      <v-icon v-if="!process.proposal" size="60" color="white">
                                        mdi-cloud-upload-outline
                                      </v-icon>
            
                                      <v-progress-circular v-else indeterminate :color="set_color" />
                                    </div>
                                  </v-img>
                                </v-card>
                              </template>
                            </uploadImgPdf>
                          </div>
                          <div v-if="form.proposal_url.length > 0 && form.proposal_url.split('.').pop() === 'pdf'">
                            <iframe :src="cdnFallback['proposal_url'] ? getCdnLegacyDisplayUrl(form.proposal_url) : getCdnDisplayUrl(form.proposal_url)"
                        @error="cdnFallback = { ...cdnFallback, 'proposal_url': true }" height="250" width="100%" frameborder="0"></iframe>
                            <div class="pt-2">
                              <v-btn
                                elevation="0"
                                dark
                                block
                                @click="form.proposal_url = ''"
                                color="red"
                                rounded>
                                <v-icon small>mdi-trash-can-outline</v-icon>
                              </v-btn>
                            </div>
                          </div>
                        </v-card-title>
                      </v-card>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="7">
                  <ValidationProvider 
                    name="Pilih Fasilitas Umum" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
    
                      Pilih Fasilitas Umum
                    </div>
    
                    <v-autocomplete
                      v-on:keyup.enter="save()"
                      
                      outlined
                      rounded
                      dense
    
                      :color="set_color"
                      placeholder="Contoh. Fasilitas Umum"
                      hide-details
                      v-model="selected_product"
                      :items="products"
                      v-on:change="fetchDetail(selected_product)"
                      item-text="name"
                      item-value="id"
                      :error-messages="errors"
                      required
                      style="border-radius: 4px;"
                      class="mb-4">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="selected_product && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>

                  <div v-if="selected_product">
                    <div>
                      <div class="form-label pb-4">
                        Pilih Jenis Pemakaian / Penggunaan
                      </div>
                      <div>
                        <v-row>
                          <v-col cols="12" md="12" class="pt-0 mb-1" v-for="(item, i) in event_cat" :key="i">
                            <table style="border: 1px solid #ededed; width: 100%; border-collapse: collapse;">
                              <tr>
                                <th colspan="2" style="font-size: 12px; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; background: aliceblue;" class="text--black font-normal">
                                  <div class="font-normal">
                                    <div>
                                      {{ item.event_cat_name }}
                                    </div>
                                  </div>
                                </th>
                              </tr>
                              <tr v-for="(event, j) in item.event" :key="j">
                                <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;" class="text--black font-normal">
                                  <div class="d-flex justify-space-between">
                                    <div>
                                      {{ event.event_name }}
                                    </div>
                                    <div>
                                      <v-btn
                                        class="submit-button text-capitalize text--white"
                                        elevation="0"
                                        :color="selected !== null && selected.event_id == event.event_id ? '#09baf7' : '#a20000'"
                                        :loading="loadingHarga && selected.event_id == event.event_id"
                                        @click="selected = event; toCheckHarga(event)"
                                        :disabled="form.start_date === '' || form.end_date === '' || form.start_date === null || form.end_date === null  || loadingHarga"
                                        style="font-size: 12px; padding: 0px 4px; margin-top: 4px; color: white;"
                                      >
                                        {{ selected !== null && selected.event_id == event.event_id ? 'Terpilih' : 'Pilih' }}
                                      </v-btn>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              <tr v-if="item.event.length == 0">
                                <td colspan="2" style="font-size: 12px; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center; width: 280px; min-width: 280px; max-width: 280px;" class="text--black">
                                  Belum Ada Jenis Pemakaian / Penggunaan
                                </td>
                              </tr>
                            </table>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </div>

                  <v-divider ></v-divider>

                  <div v-if="harga_sewa.length > 0" ref="detailHarga" class="pb-4">
                    <div class="fs-16 mt-5 font-semibold text-gray-900 mb-3">
                      Detail Pemakaian / Penggunaan
                    </div>
                    <div class="p-3 border border-gray-200">
                      <div class="font-semibold fs-14 text-gray-900 mb-2">
                        Jenis Pemakaian / Penggunaan : {{ selected.event_name }}
                      </div>
                      <v-divider></v-divider>
                      <div>
                        <table style="border: none; width: 100%; border-collapse: collapse;">
                          <tr v-for="(item, index) in harga_sewa" :key="index">
                            <td style="font-size: 12px; z-index: 1; border-left: none; padding: 8px 0px; text-align: left;" class="text--black font-normal">
                              <div class="d-flex justify-space-between">
                                <div>
                                  {{ item.date | date }}
                                </div>
                                <div>
                                  {{ (item.price*1) | price }}
                                </div>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </div>
                      <v-divider></v-divider>
                      
                      <!-- Fasilitas Tambahan -->
                      <div v-if="facilities.length > 0" class="mb-3">
                        <div class="font-semibold fs-14 text-gray-900 mb-2">
                          Fasilitas Tambahan
                        </div>
                        <div class="d-flex flex-column" style="gap: 8px;">
                          <div 
                            v-for="facility in facilities" 
                            :key="facility.product_facility_id"
                            class="d-flex align-center py-2 px-3"
                            style="border-radius: 6px; transition: background-color 0.15s;"
                            :style="selectedFacilities[facility.product_facility_id] ? 'background-color: #f0f9ff;' : 'background-color: #f9fafb;'"
                          >
                            <v-checkbox
                              :value="!!selectedFacilities[facility.product_facility_id]"
                              hide-details
                              color="primary"
                              dense
                              class="mr-2"
                              style="margin-top: 0; flex-shrink: 0;"
                              @change="(val) => handleFacilityToggle(facility, val)"
                            />
                            <div style="flex: 1; min-width: 0; display: flex; align-items: center; gap: 16px;">
                              <!-- Kiri: Nama + Harga -->
                              <div style="min-width: 0;">
                                <div class="fs-14 text-gray-900 font-medium" style="line-height: 1.3;">
                                  {{ facility.product_facility_name }}
                                </div>
                                <div class="fs-11 text-gray-500 mt-0.5">
                                  {{ (facility.product_facility_price*1) | price }} <span class="mx-1">•</span> Maks: {{ facility.product_facility_qty }}
                                </div>
                              </div>

                              <!-- Tengah: Input Qty -->
                              <div style="flex-shrink: 0;">
                                <v-select
                                  v-if="selectedFacilities[facility.product_facility_id]"
                                  v-model.number="selectedFacilities[facility.product_facility_id].qty"
                                  :items="getFacilityQtyOptions(facility)"
                                  solo
                                  dense
                                  hide-details
                                  style="width: 90px; border-radius: 6px;"
                                  class="fs-12"
                                />
                              </div>

                              <!-- Kanan: Subtotal -->
                              <div v-if="selectedFacilities[facility.product_facility_id]" class="text-right" style="min-width: 130px; flex-shrink: 0; margin-left: auto;">
                                <div class="fs-12 text-gray-900 font-medium">
                                  {{ formatPrice((selectedFacilities[facility.product_facility_id]?.qty || 0) * (parseFloat(facility.product_facility_price) || 0) * totalDays) | price }}
                                </div>
                                <div class="fs-10 text-gray-500 mt-0.5">
                                  ({{ totalDays }} hari)
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <v-divider color="black" class="my-3 border-opacity-100"></v-divider>
                      </div>
                      
                      <div class="d-flex justify-space-between my-3">
                        <div class="font-semibold fs-14 text-gray-900">
                          Total
                        </div>
                        <div class="font-semibold fs-14 text-gray-900">
                          {{ form.total | price }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="pb-5 fs-14">
                    <div class="fs-16 mt-5 font-semibold text-gray-900 mb-3">
                      Detail Pemakaian / Penggunaan
                    </div>

                    <div class="pa-5 text-center border border-gray-200 pb-5" style="border: 1px solid #e0e0e0; border-radius: 8px;">
                      Harga Pemakaian / Penggunaan belum tersedia.
                    </div>

                  </div>
                </v-col>
              </v-row>
            </v-form>
          </ValidationObserver>
        </v-card-text>
        <v-divider 
          class="mb-2"
          style="border-top: 2px dashed #e0e0e0;"/>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn 
            color="primary" 
            :loading="loading"
            :disabled="loading || !form.start_date || !form.end_date || !selected_product || !selected.event_id || !selected.event_event_cat_id || !form.name || !form.email || !form.mobilephone || !form.nik || !form.event_name || !form.event_description || !form.address"
            @click="save()">
            Simpan
          </v-btn>
          <v-btn text @click="$emit('close')">Tutup</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { getCdnDisplayUrl } from '@/utils/cdn'
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    props: {
      order: {
        type: Object,
        required: true
      },
      dialog: {
        type: Boolean,
        required: true
      },
      products: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        cdnFallback: {}, // key -> true kalau proxy CDN gagal load, dipakai getCdnLegacyDisplayUrl
        loading: false,
        selected_product: this.order.product_id || '',
        detail_product: {},
        harga_sewa: this.order.so_detail || [],
        facilities: [],
        selectedFacilities: {},
        baseTotalSewa: 0,
        form: {
          id: this.order.id || '',
          name: this.order.customer_name || '',
          email: this.order.customer_email || '',
          mobilephone: this.order.customer_mobilephone || '',
          nik: this.order.customer_nik || '',
          start_date: this.order.event_start_date || '',
          end_date: this.order.event_end_date || '',
          nik_url: this.order.nik_url || '',
          proposal_url: this.order.proposal_url || '',
          permohonan_url: '',
          event_name: this.order.event_name || '',
          address: this.order.customer_address || '',
          event_description: this.order.event_description || '',
          product_price_id_array: this.order.so_detail || [],
          total: this.order.total || 0,
          event_cat_id: this.order.event_cat_id,
          event_id: this.event_id || '',
          product_id: this.order.product_id || '',
        },
        upload: {
          image: null,
          file: null,
          proposal: null,
        },
        disabledDates: [],
        menuStart: false,
        menuEnd: false,
        startFormatted: moment(this.order.event_start_date).format('DD MMMM YYYY') || '',
        endFormatted: moment(this.order.event_end_date).format('DD MMMM YYYY') || '',
        today: moment().format('YYYY-MM-DD'),
        loadingHarga: false,
        holidays: [],
        selected: {
          event_event_cat_id: this.order.event_cat_id || '',
          event_id: this.order.event_id || '',
          event_name: this.order.event_name || '',
          event_product_id: this.order.product_id || ''
        },
        event_cat: [],
        process: {
          load: true,
          error: false,
          loadingHarga: false,
          detail: false,
          image: false,
          proposal: false,
          form: false,
        },
        message: {
          error: '',
          success: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue'),
      uploadImgPdf: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/document_pdf.vue'),
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      totalDays () {
        if (!this.form.start_date || !this.form.end_date) return 0
        const dateArray = this.getDateRangeExcludingHolidays(
          this.form.start_date,
          this.form.end_date,
          this.holidays
        )
        return dateArray.length
      },
      totalFacilities () {
        let total = 0
        const days = this.totalDays
        Object.values(this.selectedFacilities).forEach(item => {
          if (item && item.qty > 0) {
            const price = parseFloat(item.facility.product_facility_price) || 0
            total += price * item.qty * days
          }
        })
        return total
      },
    },
    watch: {
      'form.start_date'(val) {
        this.startFormatted = val ? moment(val).format('DD MMMM YYYY') : ''
      },
      'form.end_date'(val) {
        this.endFormatted = val ? moment(val).format('DD MMMM YYYY') : ''
      },
      'upload.image': {
        handler: function () {
          if (this.upload.image) {
            this.process.image = this.upload.image.process

            if (!this.process.image) {
              // CALLBACK FROM UPLOAD IMAGE
              
              // this.form.nik_url = this.upload.image.data.full.file_url
              this.form.nik_url = this.upload.image.fullpath

              // this.save_image()
            }
          }
        },
        deep: true
      },
      'upload.proposal': {
        handler: function () {
          if (this.upload.proposal) {
            this.process.proposal = this.upload.proposal.process

            if (!this.process.proposal) {
              // CALLBACK FROM UPLOAD PROPOSAL
              
              // this.form.proposal_url = this.upload.proposal.data.full.file_url
              this.form.proposal_url = this.upload.proposal.fullpath

              // this.save_proposal()
            }
          }
        },
        deep: true
      },
      totalFacilities () {
        this.form.total = this.baseTotalSewa + this.totalFacilities
      },
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail (id_product) {
        this.process.detail = true
        let params = {
          id: id_product == undefined ? this.order.product_id : id_product,
        }
        await get(`admin/product/detail`, { params })
        .then(response => {
          let res = response.data

          this.process.detail = false
            
          if (res.status === 200) {
            this.detail_product = res.results.data
            this.event_cat = []
            let event_product = []

            let eventCatRaw = res.results.data.event_cat || []
            let eventRaw = res.results.data.event || []
            let priceRaw = res.results.data.product_price || []
            let facilityRaw = res.results.data.facility || []
            
            // Filter hanya facility yang bisa dijual (product_facility_is_sell === '1')
            this.facilities = facilityRaw.filter(f => f.product_facility_is_sell === '1')

            event_product = eventRaw.map((cat) => {
              let relatePrices = priceRaw.filter((ev) => ev.event_id === cat.event_id)
              return {
                ...cat,
                price: relatePrices
              }
            })

            this.event_cat = eventCatRaw.map((cat) => {
              let relatedEvents = event_product.filter((ev) => ev.event_event_cat_id === cat.event_cat_id)
              return {
                ...cat,
                event: relatedEvents
              }
            })
            
            // Initialize selectedFacilities from existing order data (after facilities are loaded)
            this.$nextTick(() => {
              this.initSelectedFacilities()
            })

            this.fetchHolliday(this.detail_product.name)

          }
        })
      },
      
      initSelectedFacilities () {
        // Reset selectedFacilities
        this.selectedFacilities = {}
        
        // Calculate baseTotalSewa from existing harga_sewa
        if (this.harga_sewa && this.harga_sewa.length > 0) {
          const totalSewa = this.harga_sewa.reduce((acc, item) => {
            return acc + (parseFloat(item.price) || parseFloat(item.price_value) || 0)
          }, 0)
          this.baseTotalSewa = totalSewa
        }
        
        // Collect facilities from so_detail[].fasilitas_array
        const facilitiesFromSoDetail = {}
        if (this.harga_sewa && Array.isArray(this.harga_sewa) && this.harga_sewa.length > 0) {
          this.harga_sewa.forEach(soDetailItem => {
            if (soDetailItem.fasilitas_array && Array.isArray(soDetailItem.fasilitas_array)) {
              soDetailItem.fasilitas_array.forEach(facilityItem => {
                const facilityId = facilityItem.product_facility_id
                if (facilityId) {
                  // Jika sudah ada, ambil qty yang lebih besar (atau bisa juga aggregate)
                  if (!facilitiesFromSoDetail[facilityId]) {
                    facilitiesFromSoDetail[facilityId] = {
                      product_facility_id: facilityId,
                      qty: parseInt(facilityItem.qty) || 1,
                      price: parseFloat(facilityItem.price) || 0
                    }
                  } else {
                    // Ambil qty maksimum jika ada beberapa entry dengan qty berbeda
                    const currentQty = parseInt(facilitiesFromSoDetail[facilityId].qty) || 1
                    const newQty = parseInt(facilityItem.qty) || 1
                    facilitiesFromSoDetail[facilityId].qty = Math.max(currentQty, newQty)
                  }
                }
              })
            }
          })
        }
        
        // Check if order has existing facilities (from order.fasilitas_array - fallback)
        if (this.order.fasilitas_array && Array.isArray(this.order.fasilitas_array) && this.order.fasilitas_array.length > 0) {
          this.order.fasilitas_array.forEach(orderFacility => {
            const facilityId = orderFacility.product_facility_id || orderFacility.so_facility_id
            if (facilityId && !facilitiesFromSoDetail[facilityId]) {
              facilitiesFromSoDetail[facilityId] = {
                product_facility_id: facilityId,
                qty: parseInt(orderFacility.qty) || parseInt(orderFacility.so_facility_qty) || 1,
                price: parseFloat(orderFacility.price) || 0
              }
            }
          })
        }
        
        // Match collected facilities with fetched facilities and set selectedFacilities
        Object.values(facilitiesFromSoDetail).forEach(facilityData => {
          const facility = this.facilities.find(f => 
            f.product_facility_id === facilityData.product_facility_id
          )
          
          if (facility) {
            this.$set(this.selectedFacilities, facility.product_facility_id, {
              facility: facility,
              qty: facilityData.qty
            })
          }
        })
        
        // Update total after initialization
        this.$nextTick(() => {
          this.form.total = this.baseTotalSewa + this.totalFacilities
        })
      },
      async fetchHolliday (name_product) {
        let params = {
          year: moment().format('YYYY')
        }
        await get(`sites/agenda/data_sewa`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            let allAgenda = res.results.data || []
            let filtered = allAgenda.filter(item => {
              const itemDate = moment(item.date).format('YYYY-MM-DD')
              const startDate = moment(this.form.start_date).format('YYYY-MM-DD')
              return item.location === name_product && itemDate !== startDate
            })
            this.holidays = filtered.map(item => new Date(item.date))
            this.holidays = this.holidays.map(date => moment(date).format('YYYY-MM-DD'))
            this.initDisabledDates()
          }
        })
      },

      initDisabledDates() {
        this.disabledDates = this.holidays.map(date => {
          const d = new Date(date)
          return (
            d.getFullYear() + '-' +
            String(d.getMonth() + 1).padStart(2, '0') + '-' +
            String(d.getDate()).padStart(2, '0')
          )
        })
      },

      allowedDates(val) {
        const dateStr = moment(val).format('YYYY-MM-DD')
        return !this.disabledDates.includes(dateStr)
      },

      getDateRangeExcludingHolidays(startDate, endDate, holidays) {
        const dates = []
        let current = moment(startDate).startOf('day')
        const end = moment(endDate).startOf('day')

        while (current.isSameOrBefore(end)) {
          const isLibur = holidays.includes(current.format('YYYY-MM-DD'))
          if (!isLibur) {
            dates.push(current.format('YYYY-MM-DD'))
          }
          current.add(1, 'day')
        }

        return dates
      },

      async toCheckHarga (event) {
        this.message.error = ''
        this.loadingHarga = true
        this.harga_sewa = []
        this.baseTotalSewa = 0
        this.form.total = this.totalFacilities // Tetap hitung fasilitas
        this.form.product_price_id_array = []
        const date_array = this.getDateRangeExcludingHolidays(
          this.form.start_date,
          this.form.end_date,
          this.holidays
        )

        let params = {
          event_id: event.event_id,
          event_cat_id: event.event_event_cat_id,
          product_id: this.selected_product,
          date_array: JSON.stringify(date_array)
        }
        await get(`sites/order/check_harga`, { params })
        .then(response => {
          let res = response.data

          this.loadingHarga = false
            
          if (res.status === 200) {
            console.log(res.results.data)
            const result = res.results.data || []

            this.harga_sewa = result
            this.loadingHarga = false
            this.form.product_price_id_array = result
            
            // Hitung total sewa (tanpa fasilitas)
            const totalSewa = result.reduce((acc, item) => {
              return acc + (parseFloat(item.price) || 0)
            }, 0)
            
            // Update total termasuk fasilitas (total fasilitas sudah dihitung via computed)
            this.baseTotalSewa = totalSewa
            this.form.total = totalSewa + this.totalFacilities

          }
        })
      },

      handleFacilityToggle (facility, isSelected) {
        if (isSelected) {
          if (!this.selectedFacilities[facility.product_facility_id]) {
            this.$set(this.selectedFacilities, facility.product_facility_id, {
              facility,
              qty: 1
            })
          }
        } else {
          this.$delete(this.selectedFacilities, facility.product_facility_id)
        }
      },

      getFacilityQtyOptions (facility) {
        const maxQty = parseInt(facility.product_facility_qty) || 1
        return Array.from({ length: maxQty }, (_, i) => i + 1)
      },

      formatPrice (price) {
        return price
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true
          this.form.event_id = this.selected ? this.selected.event_id : ''
          this.form.event_cat_id = this.selected ? this.selected.event_event_cat_id : ''

          // Prepare fasilitas_array
          const fasilitas_array = Object.values(this.selectedFacilities)
            .filter(item => item && item.qty > 0)
            .map(item => ({
              so_facility_id: item.facility.product_facility_id,
              so_facility_qty: item.qty,
              so_facility_price: parseFloat(item.facility.product_facility_price) || 0
            }))

          // Transform product_price_id_array: jika ada property 'id', ganti ke 'price_id'
          const transformedProductPriceIdArray = (this.form.product_price_id_array || []).map(item => {
            if (item && item.hasOwnProperty('id') && !item.hasOwnProperty('price_id')) {
              const { id, ...rest } = item
              return {
                ...rest,
                price_id: id
              }
            }
            return item
          })

          // Add fasilitas_array to form data
          const formData = {
            ...this.form,
            product_price_id_array: transformedProductPriceIdArray,
            fasilitas_array: fasilitas_array
          }

          let url = 'admin/order/update'

          // SAVE TO REST API
          await post(url, {
            data: formData
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.$emit('close')
              this.$emit('update')
              this.message.success = res.message
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
    }
  }
</script>